import { useState } from 'react';
import { Page } from '../../Components/Page/Page.component';
import { Button } from '../../Components/Button/Button';
import { ExerciseLogsTable } from './ExerciseLogs.table';
import { AddExerciseLogModal } from './AddExerciseLogModal';
import { useExerciseLogsContext } from '../../Contexts/ExerciseLogs.Context';

export const ExerciseLogsPage = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const { addExerciseLog } = useExerciseLogsContext();

  console.log('Rendering');

  return (
    <Page title="Exercises">
      <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '1rem' }}>
        <Button onClick={() => setIsModalOpen(true)}>Add</Button>
      </div>
      <ExerciseLogsTable />

      <AddExerciseLogModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} onAdd={addExerciseLog} />
    </Page>
  );
};
